<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useSpacesStore} from "~/stores/spaces";

definePageMeta({
  name: "Workspaces and Environments",
});

const {workspacesWithoutDemo} = storeToRefs(useSpacesStore());
</script>

<template>
  <SidebarLayout>
    <v-alert color="primary" type="info" v-if="!workspacesWithoutDemo.length">
      <p>You are not a member of a workspace yet. To get started, please create a new Workspace and Environment
        below.</p>
    </v-alert>
    <v-row class="mb-2">
      <v-col cols="12" sm="6" md="4" lg="3" v-for="workspace of workspacesWithoutDemo" :key="workspace.identifier">
        <WorkspaceBox :workspace="workspace"/>
      </v-col>
    </v-row>
    <v-divider v-if="workspacesWithoutDemo.length" class="my-4"/>
    <v-row>
      <v-col cols="12" md="6">
        <h3 class="mb-2 pl-2">Create a workspace</h3>
        <v-card elevation="1">
          <v-card-text>
            <NewWorkspaceForm/>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <h3 class="mb-2 pl-2">About workspaces</h3>
        <v-card elevation="1">
          <v-alert color="primary" variant="tonal" title="Environments and Workspaces">
            <div>AxonIQ Console categorizes your applications in Environments and Workspaces.</div>

            <div class="mt-2">
              Applications connect to an Environment to report their metrics.
            </div>
            <div>
              You can have several Environments per Workspace, for example environments like 'Production', 'Testing',
              and 'Development'.
            </div>

            <div class="mt-2">
              Next to containing one or more Environments, the Workspace provides user management and a history view
              showing what has happened to the Workspace.
            </div>
          </v-alert>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">

      </v-col>
    </v-row>
  </SidebarLayout>
</template>
